export class SelectListItem {
    Text:string;
    Value:string;

    constructor(obj?: any){
        this.Text = obj && obj.Text || null;
        this.Value = obj && obj.Value || null;
    }
}
